const RENTALS_FEES_AND_TAXES = {
  //getFeesAndTaxes
  RENTALS_FEES_AND_TAXES: 'RENTALS_FEES_AND_TAXES',
  //getFeeAndTax
  RENTALS_FEE_AND_TAX: 'RENTALS_FEE_AND_TAX',
};

export default RENTALS_FEES_AND_TAXES;
